import React from 'react';

import { useI18n } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import { IInfoTableCell } from 'types/info-table';
import { Actions } from 'components/organisms/tep/tep-management/modals/return-modal/cells/actions';
import { ReturnedOn } from 'components/organisms/tep/tep-management/modals/return-modal/cells/returned-on';

export const useReturnColumns = () => {
  const { fc } = useI18n();

  const getCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <div>{cell.value || '-'}</div>;

  const getReturnedOnCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <ReturnedOn entryPass={cell.row} />;

  const getActionsCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <Actions entryPass={cell.row} />;

  return [
    { header: fc('name'), accessorKey: 'name', cell: getCell, width: 100, minWidth: 100 },
    { header: fc('IMEI'), accessorKey: 'device.uri', cell: getCell, minWidth: 160 },
    { header: fc('company'), accessorKey: 'lease.company', cell: getCell, minWidth: 120 },
    { header: fc('emails'), accessorKey: 'lease.email', cell: getCell, minWidth: 120 },
    { header: fc('Vehicle Plate No'), accessorKey: 'lease.plateNumber', cell: getCell, minWidth: 120 },
    { header: fc('TEP Start'), accessorKey: 'lease.startOn', cell: getCell, minWidth: 120 },
    { header: fc('TEP End'), accessorKey: 'lease.endOn', cell: getCell, minWidth: 120 },
    { header: fc('Returned On'), accessorKey: 'lease.returnedOn', cell: getReturnedOnCell, minWidth: 120 },
    { accessorKey: 'actions', header: fc('actions'), cell: getActionsCell, width: 130, minWidth: 130 },
  ];
};
